import exercise1 from './i18n/exercise1';
import exercise2 from './i18n/exercise2';
import exercise3 from './i18n/exercise3';
import exercise4 from './i18n/exercise4';
import exercise5 from './i18n/exercise5';
import exercise6 from './i18n/exercise6';
import exercise7 from './i18n/exercise7';
import exercise8 from './i18n/exercise8';
import exercise9 from './i18n/exercise9';
import exercise10 from './i18n/exercise10';
import exercise11 from './i18n/exercise11';
import exercise12 from './i18n/exercise12';
import CourseController from '../../../../../components/diagrams/course.controller';

class SpottingSCQArgumentsController extends CourseController{

  constructor(courseService, helperService, $sce, $scope) {
    "ngInject";
    super(courseService, helperService, $sce, $scope);
    Object.assign(this, { helperService, $sce });
    this.videoUrl = this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');
    // this.helperService.initIntercom();

    this.exercise1 = exercise1['en'];
    this.exercise2 = exercise2['en'];
    this.exercise3 = exercise3['en'];
    this.exercise4 = exercise4['en'];
    this.exercise5 = exercise5['en'];
    this.exercise6 = exercise6['en'];
    this.exercise7 = exercise7['en'];
    this.exercise8 = exercise8['en'];
    this.exercise9 = exercise9['en'];
    this.exercise10 = exercise10['en'];
    this.exercise11 = exercise11['en'];
    this.exercise12 = exercise12['en'];
    this.isUnit = true
    this.exerciseIdsStart = 'diagram4b2-'
    this.exerciseUserAnswers = {}

  }

}

export default SpottingSCQArgumentsController;



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/spottingSCQ.controller.js